import {Component, Input, OnInit} from '@angular/core';
import {FbSwitchButtonConfiguration} from './fb-switch-button.configuration';

@Component({
    selector: 'fb-switch-button',
    templateUrl: './fb-switch-button.component.html',
    styleUrls: ['./fb-switch-button.component.scss']
})
export class FbSwitchButtonComponent {

    @Input() configuration!: FbSwitchButtonConfiguration;

    constructor() {
    }

    toggle() {

        this.configuration.onChangeFunction();

    }

}
